import { cn } from '@utils/cn'

export default function Skeleton({
  className='',
  ...props
}) {  
  return (
    <div
      className={cn('animate-pulse rounded-md bg-pebble-100', className)}
      {...props}
    />
  )
}
